import React, { ReactNode } from "react";
import styled from "styles/styled_components";
import title from "styles/title";

import InfoTooltip from "components/shared/info_tooltip";

interface IStyledLaborTitle {
  align?: "left" | "center";
  hasInfo?: boolean;
}

interface ILaborTitle extends IStyledLaborTitle {
  children: ReactNode;
  info?: ReactNode;
}

const INFO_SIZE = "16px";

const StyledLaborTitle = styled("header")<IStyledLaborTitle>`
  border-bottom: 1px solid ${(props) => props.theme.colors.dsGrayLight};
  line-height: ${(props) => props.theme.text.lineHeight.small};
  margin-bottom: 7px;
  padding-bottom: ${(props) => props.theme.spacing.xsmall};
  position: relative;
  text-align: ${(props) => props.align || "center"};
  ${(props) =>
    props.hasInfo &&
    `
    padding-right: ${INFO_SIZE};
    & .LaborTitleTooltip {
      position: absolute;
      top: 1px;
      right: 0;
    }
  `}
`;

const StyledTitle = styled.span`
  font-family: ${(props) => props.theme.text.mediumFamily};
  font-size: ${(props) => props.theme.text.size.base};
  ${title}
`;

function LaborTitle({ align, children, info }: ILaborTitle) {
  return (
    <StyledLaborTitle align={align} hasInfo={!!info}>
      <StyledTitle>{children}</StyledTitle>
      {info && (
        <InfoTooltip className="LaborTitleTooltip" size={INFO_SIZE}>
          {info}
        </InfoTooltip>
      )}
    </StyledLaborTitle>
  );
}

export default LaborTitle;
